
import Layout from "../../components/mainPage/Layout";
import { AppRoute } from "../../constants";
import { ImageContainer } from "shared/components/ImageContainer";
import skarch from "../../images/station-controller-architecture.png";
import skweb from "../../images/station-controller-web.png";
import skupdate from "../../images/station-controller-update.png";
export const Page = ({ }) => {

  return (
    <Layout>
      <div className="container">
        <div className="article-container">
          <h1 className="mb-4 ">
            Программное обеспечение сервера СКСУ
          </h1>
          <p className="article-lead">
            Основной задачей ПО сервера СКСУ является интеграция устройств в SCADA
            по различным промышленным протоколам (МЭК 61850, МЭК 60870-5-104/101,
            МЭК 60870-5-103, Modbus TCP, Modbus RTU и т.д.).
            <br />
            Полный перечень протоколов и интегрируемых устройств с помощью ПО СКСУ
            приведен в{" "}
            <a href={`/${AppRoute.IntegratedDevices}`} className="text-links">
              таблице протоколов и интегрируемых устройств
            </a>
            .
          </p>



          <h2 className="section-title">Архитектура программных средств</h2>
          <p>
            Программное обеспечение сервера СКСУ состоит из набора отдельных
            сервисов. Функционал интеграции с устройствами выполняют
            коммуникационные сервисы (драйверы). Для интеграции каждого устройства
            создается свой коммуникационный сервис, позволяющий интегрировать
            устройство по соответствующем протоколу.
          </p>

          <div className="quote-box-list">
            <div className="quote-box">
              <h3 className="feature-title">Коммуникационные сервисы</h3>
              <p>
                Каждый коммуникационный сервис запускается отдельным процессом и
                может быть перезапущен отдельно от других сервисов, не влияя на их
                работу.
              </p>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">Системный диспетчер</h3>
              <p>
                За коммуникацию между сервисами отвечает специализированный
                сервис, под названием <strong>Системный диспетчер</strong>.
              </p>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">Менеджер процессов</h3>
              <p>
                Для контроля работы сервисов служит{" "}
                <strong>Менеджер процессов</strong>. Он отслеживает исправность
                всех сервисов и осуществляет перезапуск сервисов в случае
                нештатной ситуации, а также при загрузке конфигурации на Сервер.
              </p>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">Контроль ОС</h3>
              <p>
                В Windows контроль осуществляется встроенной системой
                автоматического перезапуска служб.
                <br />В Linux контроль выполняется утилитой{" "}
                <strong>monitd</strong>, которая находится под контролем ОС.
              </p>
            </div>
          </div>
          <ImageContainer
            style={{ width: "80%" }}
            src={skarch}
            alt="Архитектура ПО сервера СКСУ"
            caption={'Архитектура ПО сервера СКСУ'}
          />




          <h2 className="section-title">Веб-интерфейс</h2>
          <p>
            Веб-интерфейс позволяет производить мониторинг работы ПО СКСУ через
            браузер.
          </p>

          <div className="quote-box-list">
            <div className="quote-box">
              <h3 className="feature-title">Контроль сервисов</h3>
              <ul>
                <li>Отслеживание статуса сервиса (в работе/остановлен/отказ)</li>
                <li>Смена режима работы сервисов (автоматический или ручной)</li>
                <li>Возможность перезапуска сервисов</li>
              </ul>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">Диагностическая информация</h3>
              <ul>
                <li>Сетевые интерфейсы</li>
                <li>Быстродействие системы</li>
                <li>Состояние накопителей</li>
                <li>Статистика кластера и памяти</li>
              </ul>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">Синхронизация времени</h3>
              <ul>
                <li>Контроль статуса NTP сервера</li>
                <li>Мониторинг количества спутников GPS/ГЛОНАСС</li>
                <li>Синхронизация с удаленного АРМ</li>
              </ul>
            </div>
          </div>


          <ImageContainer
            src={skweb}
            alt="Веб-интерфейс ПО СКСУ"
            caption={'Веб-интерфейс мониторинга ПО СКСУ'}
          />


          <h2 className="section-title">Обновление ПО</h2>
          <p>
            Веб-интерфейс позволяет производить обновление ПО СКСУ. Возможно как
            полное обновление с помощью пакета ПО СКСУ в системном формате, так и
            отдельное обновление драйверов устройств.
          </p>

          <div className="quote-box">
            <h3 className="feature-title">Процедура обновления:</h3>
            <ol>
              <li>В разделе "Обновление" нажать "Выбрать файл"</li>
              <li>Выбрать соответствующий файл обновления</li>
              <li>Нажать "Отправить"</li>
            </ol>

            <div className="file-formats">
              <h4>Форматы файлов:</h4>
              <ul>
                <li>Полное обновление: *.deb, *.ipkg, *.msi, *.rpm</li>
                <li>
                  Частичное обновление: lib&lt;driver&gt;.so (Linux),
                  &lt;driver&gt;.dll (Windows)
                </li>
              </ul>
            </div>
          </div>


          <ImageContainer
            src={skupdate}
            alt="Интерфейс обновления ПО СКСУ"
            caption={'Интерфейс обновления ПО СКСУ'}
          />


          <h2 className="section-title">Диагностика в SCADA</h2>
          <p>
            Модуль диагностики позволяет производить мониторинг работы Сервера и
            всех опрашиваемых устройств с помощью SCADA.
          </p>

          <div className="quote-box-list">
            <div className="quote-box">
              <h3 className="feature-title">Инструменты мониторинга</h3>
              <ul>
                <li>Ведомость событий</li>
                <li>Журнал тревог</li>
                <li>Диагностические мнемосхемы</li>
              </ul>
            </div>

            <div className="quote-box">
              <h3 className="feature-title">Преимущества</h3>
              <ul>
                <li>Заблаговременное отслеживание ошибок</li>
                <li>Оперативное реагирование на нештатные ситуации</li>
                <li>Централизованный контроль всех устройств</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </Layout>

  );
};

export const meta = {
  title: 'Программное обеспечение сервера СКСУ',
  description: `Основной задачей ПО сервера СКСУ является интеграция устройств в SCADA
            по различным промышленным протоколам (МЭК 61850, МЭК 60870-5-104/101,
            МЭК 60870-5-103, Modbus TCP, Modbus RTU и т.д.).`
}